// extracted by mini-css-extract-plugin
export var avatarContainer = "_ft-0";
export var gray = "_ft-f";
export var green = "_ft-c";
export var icon = "_ft-9";
export var image = "_ft-1";
export var lg = "_ft-6";
export var md = "_ft-5";
export var presenceDot = "_ft-b";
export var red = "_ft-d";
export var sm = "_ft-4";
export var status = "_ft-a";
export var xl = "_ft-7";
export var xs = "_ft-3";
export var xxl = "_ft-8";
export var xxs = "_ft-2";
export var yellow = "_ft-e";